






































import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"

@Component({
	components: {}
})
export default class Picture extends AbpBase {
	url = XMLHTTP_BASEURL
	@Prop({type: String, default:""}) data: string
	@Prop({type: Boolean, default: false}) value: Boolean
	canvasWidth = 1200
	canvasHeight = 600
	canvasMoveUse = false
	canvas: any = {}
	context: any = {}
	preDrawAry: Array<any> = []
	middleAry: Array<any> = []
	nextDrawAry: Array<any> = []
	imgSrc = ""

	save() {
		let base64Data = this.canvas.toDataURL("image/png")
		this.imgSrc = base64Data
		var blob = this.dataURItoBlob(base64Data);
		var fd = new FormData();
		fd.append("fileData", blob)
		fd.append("fileName", Date.now() + ".png")
		var xmlHttp = new XMLHttpRequest()
		xmlHttp.open("POST", this.url + 'api/services/app/Helper/FileSave');
		xmlHttp.send(fd);
		let saved = false
		//ajax回调
		xmlHttp.onreadystatechange = () => {
			console.log(xmlHttp.response)
			if (!saved && xmlHttp.response) {
				let response = JSON.parse(xmlHttp.response)
				if (response.result.status === 1) {
					this.$emit("save-success", response.result.objects.imageAddress)
					saved = true
				}
			}
		}
	}

	cancel() {
		this.$emit('input', false)
	}

	fileClick() {
		const file: any = this.$refs.file as any
		const vm = this
		file.click();
		file.onchange = function () {
			const files = this.files;
			vm.handleFileSelect2(files)
		}
	}

	isImage(type: String) {
		switch (type) {
			case 'image/jpeg':
			case 'image/png':
			case 'image/gif':
			case 'image/bmp':
			case 'image/jpg':
				return true;
			default:
				return false;
		}
	}
	mounted(){
		const canvas: any = this.$refs.canvas
		this.canvas = canvas
		this.context = canvas.getContext('2d')
		// if (this.data !== "") {
		// 	const image:any = new Image()  //this.$refs.img
		// 	image.src = this.url + this.data
		// 	image.crossOrigin = "anonymous"
		// 	const vm = this
		// 	image.onload = function () {
		// 		let hRatio
		// 		let wRatio
		// 		let l = 0;
		// 		let t = 0
		// 		let maxWidth = 1200
		// 		let maxHeight = 600
		// 		let Ratio = 1
		// 		let w = image.width
		// 		let h = image.height
		// 		wRatio = maxWidth / w
		// 		hRatio = maxHeight / h
		// 		// 图像大小超出绘画板大小，计算出缩放比例
		// 		if (wRatio<1 || hRatio<1){
		// 			Ratio = (wRatio<=hRatio?wRatio:hRatio)
		// 		}
		// 		// 根据比例重新设置图像大小
		// 		if (Ratio<1){
		// 			w = w * Ratio
		// 			h = h * Ratio
		// 		}
		// 		// 图片居中摆放
		// 		l = (maxWidth - w)/2
		// 		t = (maxHeight - h)/2
		// 		// 高度制定为canvas的高度，宽度按宽度来缩放
		// 		image.width = (image.width / image.height) * 600
		// 		image.height = 600
		// 		// drawImage https://developer.mozilla.org/zh-CN/docs/Web/API/CanvasRenderingContext2D/drawImage
		// 		vm.context.drawImage(image, 0, 0,  image.width, image.height) //,l , t , w , h
		// 		var dataURL = vm.canvas.toDataURL("image/png");
		//
		// 		console.log(dataURL.replace(/^data:image\/(png|jpg);base64,/, ""))
		// 	}
		// }
	}
	handleFileSelect2(files: any) {
		const f = files[0]
		const type = f.type ? f.type : 'n/a';
		const reader = new FileReader();
		const isImg = this.isImage(type);
		const vm = this
		// 处理得到的图片
		if (isImg) {
			this.context.clearRect(0,0,1200,600)
			const URL = window.URL
			const image = new Image()
			const imgURL = URL.createObjectURL(f)
			image.src = imgURL
			image.onload = function () {
				let hRatio
				let wRatio
				let l = 0;
				let t = 0
				let maxWidth = 1200
				let maxHeight = 600
				let Ratio = 1
				let w = image.width
				let h = image.height
				wRatio = maxWidth / w
				hRatio = maxHeight / h
				// 图像大小超出绘画板大小，计算出缩放比例
				if (wRatio<1 || hRatio<1){
					Ratio = (wRatio<=hRatio?wRatio:hRatio)
				}
				// 根据比例重新设置图像大小
				if (Ratio<1){
					w = w * Ratio
					h = h * Ratio
				}
				// 图片居中摆放
				l = (maxWidth - w)/2
				t = (maxHeight - h)/2
				// 高度制定为canvas的高度，宽度按宽度来缩放
				image.width = (image.width / image.height) * 600
				image.height = 600
				// drawImage https://developer.mozilla.org/zh-CN/docs/Web/API/CanvasRenderingContext2D/drawImage
				vm.context.drawImage(image, 0, 0,  image.width, image.height) //,l , t , w , h
			}
		} else {
			this.$Message.error("请选择图片文件！")
		}
	}

	dataURItoBlob(base64Data: any) {
		var byteString;
		if (base64Data.split(',')[0].indexOf('base64') >= 0)
			byteString = atob(base64Data.split(',')[1]);
		else
			byteString = unescape(base64Data.split(',')[1]);
		var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
		var ia = new Uint8Array(byteString.length);
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}
		return new Blob([ia], {type: mimeString});
	}

	canvasDown(e: any) {
		console.log('canvasDown')
		this.canvasMoveUse = true
		const canvas = this.canvas
		console.log("document.body.scrollTop", document.body.scrollTop)
		console.log("e", e.clientX, e.clientY)
		const canvasX = e.clientX - canvas.offsetLeft - document.body.scrollLeft
		const canvasY = e.clientY - canvas.offsetTop - 52 - document.body.scrollTop
		this.setCanvasStyle()
		this.context.beginPath()
		this.context.moveTo(canvasX, canvasY)
		console.log('moveTo', canvasX, canvasY)
		// document.onmousemove = (event) => {
		//
		// }
		// const preData = this.context.getImageData(0, 0, 1056, 800)
		// this.preDrawAry.push(preData)
	}

	canvasMove(e: any) {
		if (this.canvasMoveUse) {
			console.log('canvasMove')
			const canvas = this.canvas
			console.log("e.clientX", e.clientX)
			let canvasX
			let canvasY
			if (this.isPc()) {
				canvasX = e.clientX - canvas.offsetLeft - document.body.scrollLeft
				canvasY = e.clientY - canvas.offsetTop - 52 - document.body.scrollTop
			} else {
				canvasX = e.changedTouches[0].clientX - canvas.offsetLeft
				canvasY = e.changedTouches[0].clientY - canvas.offsetTop - 52
			}
			this.context.lineTo(canvasX, canvasY)
			this.context.stroke()
		}
		e.stopPropagation()
		e.preventDefault()
	}

	canvasUp(e: any) {
		console.log('canvasUp')
		// const preData = this.context.getImageData(0, 0, 1056, 800)
		// if (!this.nextDrawAry.length) {
		// 	this.middleAry.push(preData)
		// } else {
		// 	this.middleAry = []
		// 	this.middleAry = this.middleAry.concat(this.preDrawAry)
		// 	this.middleAry.push(preData)
		// 	this.nextDrawAry = []
		// }
		this.canvasMoveUse = false
	}

	isPc() {
		const userAgentInfo = navigator.userAgent
		const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
		let flag = true
		for (let v = 0; v < Agents.length; v++) {
			if (userAgentInfo.indexOf(Agents[v]) > 0) {
				flag = false
				break
			}
		}
		return flag
	}

	setCanvasStyle() {
		this.context.lineWidth = 1
		this.context.shadowBlur = 1
		this.context.shadowColor = 'black'
		this.context.strokeStyle = 'black'
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', false)
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/road/picture.vue